"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _MandantFile = _interopRequireDefault(require("./MandantFile"));
var _MandantenFooter = _interopRequireDefault(require("./MandantenFooter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Mandanteninfos model module.
 * @module model/Mandanteninfos
 * @version 1.0.44
 */
var Mandanteninfos = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Mandanteninfos</code>.
   * Alle iNfos zu einem Mandanten
   * @alias module:model/Mandanteninfos
   * @param theme {String} Bankentyp
   * @param headertitle {String} Titel des Headers
   * @param headerLink {String} Link zu Header
   * @param headerlogo1 {String} Pfad zu Logo 1
   * @param headeralt1 {String} alte Headerdaten
   * @param telefon {String} Telefonnummer
   * @param mail {String} Mail-Adresse
   * @param rueckruf {String} Telefonnummer
   * @param terminLink {String} Link zum Termin vereinbaren
   * @param chat {String} Chat Kanal
   * @param bildschirmteilen {String} Url zum Bildschirm teilen
   * @param kontaktdaten {String} Url zu Kontaktdaten
   * @param mailTitle {String} Titel zur Mail
   * @param rueckrufTitle {String} Titel zur Telefonnummer
   * @param terminLinkTitle {String} Titel zur Link für Terminvereinbarung
   * @param chatTitle {String} Konstante für Titel zum Chat
   * @param bildschirmteilenTitle {String} Konstante für Titel zum Bildschirmteilen
   * @param kontaktdatenTitle {String} Konstante für Titel zu Kontaktdaten
   * @param kontaktImage {String} Url zu Kontaktdaten Bild
   * @param lieferadresseKz {String} Lieferadresse kürzel
   * @param yesVerifiedAdresseKz {String} Kürzel für YES-Adresse
   * @param agb {String} Link zur AGB
   * @param sammelPostkorb {String} Mail-Adresse des Sammelpostkorbs für den Mandanten
   * @param vviLink {String} Link
   * @param mandantFooterList {Array.<module:model/MandantenFooter>} Liste von Mandanten Footern
   * @param id {Number}
   * @param gpNummer {String}
   * @param searchLieferadresseAktiv {String} Lieferadressensuche aktiv
   * @param abwAdresseBsErlaubt {String} Abweichende Adresse im Beratershop erlaubt
   */
  function Mandanteninfos(theme, headertitle, headerLink, headerlogo1, headeralt1, telefon, mail, rueckruf, terminLink, chat, bildschirmteilen, kontaktdaten, mailTitle, rueckrufTitle, terminLinkTitle, chatTitle, bildschirmteilenTitle, kontaktdatenTitle, kontaktImage, lieferadresseKz, yesVerifiedAdresseKz, agb, sammelPostkorb, vviLink, mandantFooterList, id, gpNummer, searchLieferadresseAktiv, abwAdresseBsErlaubt) {
    _classCallCheck(this, Mandanteninfos);
    Mandanteninfos.initialize(this, theme, headertitle, headerLink, headerlogo1, headeralt1, telefon, mail, rueckruf, terminLink, chat, bildschirmteilen, kontaktdaten, mailTitle, rueckrufTitle, terminLinkTitle, chatTitle, bildschirmteilenTitle, kontaktdatenTitle, kontaktImage, lieferadresseKz, yesVerifiedAdresseKz, agb, sammelPostkorb, vviLink, mandantFooterList, id, gpNummer, searchLieferadresseAktiv, abwAdresseBsErlaubt);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Mandanteninfos, null, [{
    key: "initialize",
    value: function initialize(obj, theme, headertitle, headerLink, headerlogo1, headeralt1, telefon, mail, rueckruf, terminLink, chat, bildschirmteilen, kontaktdaten, mailTitle, rueckrufTitle, terminLinkTitle, chatTitle, bildschirmteilenTitle, kontaktdatenTitle, kontaktImage, lieferadresseKz, yesVerifiedAdresseKz, agb, sammelPostkorb, vviLink, mandantFooterList, id, gpNummer, searchLieferadresseAktiv, abwAdresseBsErlaubt) {
      obj['theme'] = theme;
      obj['headertitle'] = headertitle;
      obj['headerLink'] = headerLink;
      obj['headerlogo1'] = headerlogo1;
      obj['headeralt1'] = headeralt1;
      obj['telefon'] = telefon;
      obj['mail'] = mail;
      obj['rueckruf'] = rueckruf;
      obj['terminLink'] = terminLink;
      obj['chat'] = chat;
      obj['bildschirmteilen'] = bildschirmteilen;
      obj['kontaktdaten'] = kontaktdaten;
      obj['mailTitle'] = mailTitle;
      obj['rueckrufTitle'] = rueckrufTitle;
      obj['terminLinkTitle'] = terminLinkTitle;
      obj['chatTitle'] = chatTitle;
      obj['bildschirmteilenTitle'] = bildschirmteilenTitle;
      obj['kontaktdatenTitle'] = kontaktdatenTitle;
      obj['kontaktImage'] = kontaktImage;
      obj['lieferadresseKz'] = lieferadresseKz;
      obj['yesVerifiedAdresseKz'] = yesVerifiedAdresseKz;
      obj['agb'] = agb;
      obj['sammelPostkorb'] = sammelPostkorb;
      obj['vviLink'] = vviLink;
      obj['mandantFooterList'] = mandantFooterList;
      obj['id'] = id;
      obj['gpNummer'] = gpNummer;
      obj['searchLieferadresseAktiv'] = searchLieferadresseAktiv;
      obj['abwAdresseBsErlaubt'] = abwAdresseBsErlaubt;
    }

    /**
     * Constructs a <code>Mandanteninfos</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Mandanteninfos} obj Optional instance to populate.
     * @return {module:model/Mandanteninfos} The populated <code>Mandanteninfos</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Mandanteninfos();
        if (data.hasOwnProperty('theme')) {
          obj['theme'] = _ApiClient.default.convertToType(data['theme'], 'String');
        }
        if (data.hasOwnProperty('soKonditionenKz')) {
          obj['soKonditionenKz'] = _ApiClient.default.convertToType(data['soKonditionenKz'], 'String');
        }
        if (data.hasOwnProperty('emKonditionenKz')) {
          obj['emKonditionenKz'] = _ApiClient.default.convertToType(data['emKonditionenKz'], 'String');
        }
        if (data.hasOwnProperty('headertitle')) {
          obj['headertitle'] = _ApiClient.default.convertToType(data['headertitle'], 'String');
        }
        if (data.hasOwnProperty('headerLink')) {
          obj['headerLink'] = _ApiClient.default.convertToType(data['headerLink'], 'String');
        }
        if (data.hasOwnProperty('headerlogo1')) {
          obj['headerlogo1'] = _ApiClient.default.convertToType(data['headerlogo1'], 'String');
        }
        if (data.hasOwnProperty('headerlogo2')) {
          obj['headerlogo2'] = _ApiClient.default.convertToType(data['headerlogo2'], 'String');
        }
        if (data.hasOwnProperty('headerlogo3')) {
          obj['headerlogo3'] = _ApiClient.default.convertToType(data['headerlogo3'], 'String');
        }
        if (data.hasOwnProperty('headeralt1')) {
          obj['headeralt1'] = _ApiClient.default.convertToType(data['headeralt1'], 'String');
        }
        if (data.hasOwnProperty('headeralt2')) {
          obj['headeralt2'] = _ApiClient.default.convertToType(data['headeralt2'], 'String');
        }
        if (data.hasOwnProperty('headeralt3')) {
          obj['headeralt3'] = _ApiClient.default.convertToType(data['headeralt3'], 'String');
        }
        if (data.hasOwnProperty('headerbankname1')) {
          obj['headerbankname1'] = _ApiClient.default.convertToType(data['headerbankname1'], 'String');
        }
        if (data.hasOwnProperty('headerbankname2')) {
          obj['headerbankname2'] = _ApiClient.default.convertToType(data['headerbankname2'], 'String');
        }
        if (data.hasOwnProperty('telefon')) {
          obj['telefon'] = _ApiClient.default.convertToType(data['telefon'], 'String');
        }
        if (data.hasOwnProperty('mail')) {
          obj['mail'] = _ApiClient.default.convertToType(data['mail'], 'String');
        }
        if (data.hasOwnProperty('rueckruf')) {
          obj['rueckruf'] = _ApiClient.default.convertToType(data['rueckruf'], 'String');
        }
        if (data.hasOwnProperty('terminLink')) {
          obj['terminLink'] = _ApiClient.default.convertToType(data['terminLink'], 'String');
        }
        if (data.hasOwnProperty('chat')) {
          obj['chat'] = _ApiClient.default.convertToType(data['chat'], 'String');
        }
        if (data.hasOwnProperty('bildschirmteilen')) {
          obj['bildschirmteilen'] = _ApiClient.default.convertToType(data['bildschirmteilen'], 'String');
        }
        if (data.hasOwnProperty('kontaktdaten')) {
          obj['kontaktdaten'] = _ApiClient.default.convertToType(data['kontaktdaten'], 'String');
        }
        if (data.hasOwnProperty('mailTitle')) {
          obj['mailTitle'] = _ApiClient.default.convertToType(data['mailTitle'], 'String');
        }
        if (data.hasOwnProperty('rueckrufTitle')) {
          obj['rueckrufTitle'] = _ApiClient.default.convertToType(data['rueckrufTitle'], 'String');
        }
        if (data.hasOwnProperty('terminLinkTitle')) {
          obj['terminLinkTitle'] = _ApiClient.default.convertToType(data['terminLinkTitle'], 'String');
        }
        if (data.hasOwnProperty('chatTitle')) {
          obj['chatTitle'] = _ApiClient.default.convertToType(data['chatTitle'], 'String');
        }
        if (data.hasOwnProperty('bildschirmteilenTitle')) {
          obj['bildschirmteilenTitle'] = _ApiClient.default.convertToType(data['bildschirmteilenTitle'], 'String');
        }
        if (data.hasOwnProperty('kontaktdatenTitle')) {
          obj['kontaktdatenTitle'] = _ApiClient.default.convertToType(data['kontaktdatenTitle'], 'String');
        }
        if (data.hasOwnProperty('kontaktImage')) {
          obj['kontaktImage'] = _ApiClient.default.convertToType(data['kontaktImage'], 'String');
        }
        if (data.hasOwnProperty('lieferadresseKz')) {
          obj['lieferadresseKz'] = _ApiClient.default.convertToType(data['lieferadresseKz'], 'String');
        }
        if (data.hasOwnProperty('yesVerifiedAdresseKz')) {
          obj['yesVerifiedAdresseKz'] = _ApiClient.default.convertToType(data['yesVerifiedAdresseKz'], 'String');
        }
        if (data.hasOwnProperty('fileList')) {
          obj['fileList'] = _ApiClient.default.convertToType(data['fileList'], [_MandantFile.default]);
        }
        if (data.hasOwnProperty('agb')) {
          obj['agb'] = _ApiClient.default.convertToType(data['agb'], 'String');
        }
        if (data.hasOwnProperty('sammelPostkorb')) {
          obj['sammelPostkorb'] = _ApiClient.default.convertToType(data['sammelPostkorb'], 'String');
        }
        if (data.hasOwnProperty('vviLink')) {
          obj['vviLink'] = _ApiClient.default.convertToType(data['vviLink'], 'String');
        }
        if (data.hasOwnProperty('mandantFooterList')) {
          obj['mandantFooterList'] = _ApiClient.default.convertToType(data['mandantFooterList'], [_MandantenFooter.default]);
        }
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('gpNummer')) {
          obj['gpNummer'] = _ApiClient.default.convertToType(data['gpNummer'], 'String');
        }
        if (data.hasOwnProperty('issuerUrl')) {
          obj['issuerUrl'] = _ApiClient.default.convertToType(data['issuerUrl'], 'String');
        }
        if (data.hasOwnProperty('schwellenwert')) {
          obj['schwellenwert'] = _ApiClient.default.convertToType(data['schwellenwert'], 'Number');
        }
        if (data.hasOwnProperty('searchLieferadresseAktiv')) {
          obj['searchLieferadresseAktiv'] = _ApiClient.default.convertToType(data['searchLieferadresseAktiv'], 'String');
        }
        if (data.hasOwnProperty('abwAdresseBsErlaubt')) {
          obj['abwAdresseBsErlaubt'] = _ApiClient.default.convertToType(data['abwAdresseBsErlaubt'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Mandanteninfos</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Mandanteninfos</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Mandanteninfos.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['theme'] && !(typeof data['theme'] === 'string' || data['theme'] instanceof String)) {
        throw new Error("Expected the field `theme` to be a primitive type in the JSON string but got " + data['theme']);
      }
      // ensure the json data is a string
      if (data['soKonditionenKz'] && !(typeof data['soKonditionenKz'] === 'string' || data['soKonditionenKz'] instanceof String)) {
        throw new Error("Expected the field `soKonditionenKz` to be a primitive type in the JSON string but got " + data['soKonditionenKz']);
      }
      // ensure the json data is a string
      if (data['emKonditionenKz'] && !(typeof data['emKonditionenKz'] === 'string' || data['emKonditionenKz'] instanceof String)) {
        throw new Error("Expected the field `emKonditionenKz` to be a primitive type in the JSON string but got " + data['emKonditionenKz']);
      }
      // ensure the json data is a string
      if (data['headertitle'] && !(typeof data['headertitle'] === 'string' || data['headertitle'] instanceof String)) {
        throw new Error("Expected the field `headertitle` to be a primitive type in the JSON string but got " + data['headertitle']);
      }
      // ensure the json data is a string
      if (data['headerLink'] && !(typeof data['headerLink'] === 'string' || data['headerLink'] instanceof String)) {
        throw new Error("Expected the field `headerLink` to be a primitive type in the JSON string but got " + data['headerLink']);
      }
      // ensure the json data is a string
      if (data['headerlogo1'] && !(typeof data['headerlogo1'] === 'string' || data['headerlogo1'] instanceof String)) {
        throw new Error("Expected the field `headerlogo1` to be a primitive type in the JSON string but got " + data['headerlogo1']);
      }
      // ensure the json data is a string
      if (data['headerlogo2'] && !(typeof data['headerlogo2'] === 'string' || data['headerlogo2'] instanceof String)) {
        throw new Error("Expected the field `headerlogo2` to be a primitive type in the JSON string but got " + data['headerlogo2']);
      }
      // ensure the json data is a string
      if (data['headerlogo3'] && !(typeof data['headerlogo3'] === 'string' || data['headerlogo3'] instanceof String)) {
        throw new Error("Expected the field `headerlogo3` to be a primitive type in the JSON string but got " + data['headerlogo3']);
      }
      // ensure the json data is a string
      if (data['headeralt1'] && !(typeof data['headeralt1'] === 'string' || data['headeralt1'] instanceof String)) {
        throw new Error("Expected the field `headeralt1` to be a primitive type in the JSON string but got " + data['headeralt1']);
      }
      // ensure the json data is a string
      if (data['headeralt2'] && !(typeof data['headeralt2'] === 'string' || data['headeralt2'] instanceof String)) {
        throw new Error("Expected the field `headeralt2` to be a primitive type in the JSON string but got " + data['headeralt2']);
      }
      // ensure the json data is a string
      if (data['headeralt3'] && !(typeof data['headeralt3'] === 'string' || data['headeralt3'] instanceof String)) {
        throw new Error("Expected the field `headeralt3` to be a primitive type in the JSON string but got " + data['headeralt3']);
      }
      // ensure the json data is a string
      if (data['headerbankname1'] && !(typeof data['headerbankname1'] === 'string' || data['headerbankname1'] instanceof String)) {
        throw new Error("Expected the field `headerbankname1` to be a primitive type in the JSON string but got " + data['headerbankname1']);
      }
      // ensure the json data is a string
      if (data['headerbankname2'] && !(typeof data['headerbankname2'] === 'string' || data['headerbankname2'] instanceof String)) {
        throw new Error("Expected the field `headerbankname2` to be a primitive type in the JSON string but got " + data['headerbankname2']);
      }
      // ensure the json data is a string
      if (data['telefon'] && !(typeof data['telefon'] === 'string' || data['telefon'] instanceof String)) {
        throw new Error("Expected the field `telefon` to be a primitive type in the JSON string but got " + data['telefon']);
      }
      // ensure the json data is a string
      if (data['mail'] && !(typeof data['mail'] === 'string' || data['mail'] instanceof String)) {
        throw new Error("Expected the field `mail` to be a primitive type in the JSON string but got " + data['mail']);
      }
      // ensure the json data is a string
      if (data['rueckruf'] && !(typeof data['rueckruf'] === 'string' || data['rueckruf'] instanceof String)) {
        throw new Error("Expected the field `rueckruf` to be a primitive type in the JSON string but got " + data['rueckruf']);
      }
      // ensure the json data is a string
      if (data['terminLink'] && !(typeof data['terminLink'] === 'string' || data['terminLink'] instanceof String)) {
        throw new Error("Expected the field `terminLink` to be a primitive type in the JSON string but got " + data['terminLink']);
      }
      // ensure the json data is a string
      if (data['chat'] && !(typeof data['chat'] === 'string' || data['chat'] instanceof String)) {
        throw new Error("Expected the field `chat` to be a primitive type in the JSON string but got " + data['chat']);
      }
      // ensure the json data is a string
      if (data['bildschirmteilen'] && !(typeof data['bildschirmteilen'] === 'string' || data['bildschirmteilen'] instanceof String)) {
        throw new Error("Expected the field `bildschirmteilen` to be a primitive type in the JSON string but got " + data['bildschirmteilen']);
      }
      // ensure the json data is a string
      if (data['kontaktdaten'] && !(typeof data['kontaktdaten'] === 'string' || data['kontaktdaten'] instanceof String)) {
        throw new Error("Expected the field `kontaktdaten` to be a primitive type in the JSON string but got " + data['kontaktdaten']);
      }
      // ensure the json data is a string
      if (data['mailTitle'] && !(typeof data['mailTitle'] === 'string' || data['mailTitle'] instanceof String)) {
        throw new Error("Expected the field `mailTitle` to be a primitive type in the JSON string but got " + data['mailTitle']);
      }
      // ensure the json data is a string
      if (data['rueckrufTitle'] && !(typeof data['rueckrufTitle'] === 'string' || data['rueckrufTitle'] instanceof String)) {
        throw new Error("Expected the field `rueckrufTitle` to be a primitive type in the JSON string but got " + data['rueckrufTitle']);
      }
      // ensure the json data is a string
      if (data['terminLinkTitle'] && !(typeof data['terminLinkTitle'] === 'string' || data['terminLinkTitle'] instanceof String)) {
        throw new Error("Expected the field `terminLinkTitle` to be a primitive type in the JSON string but got " + data['terminLinkTitle']);
      }
      // ensure the json data is a string
      if (data['chatTitle'] && !(typeof data['chatTitle'] === 'string' || data['chatTitle'] instanceof String)) {
        throw new Error("Expected the field `chatTitle` to be a primitive type in the JSON string but got " + data['chatTitle']);
      }
      // ensure the json data is a string
      if (data['bildschirmteilenTitle'] && !(typeof data['bildschirmteilenTitle'] === 'string' || data['bildschirmteilenTitle'] instanceof String)) {
        throw new Error("Expected the field `bildschirmteilenTitle` to be a primitive type in the JSON string but got " + data['bildschirmteilenTitle']);
      }
      // ensure the json data is a string
      if (data['kontaktdatenTitle'] && !(typeof data['kontaktdatenTitle'] === 'string' || data['kontaktdatenTitle'] instanceof String)) {
        throw new Error("Expected the field `kontaktdatenTitle` to be a primitive type in the JSON string but got " + data['kontaktdatenTitle']);
      }
      // ensure the json data is a string
      if (data['kontaktImage'] && !(typeof data['kontaktImage'] === 'string' || data['kontaktImage'] instanceof String)) {
        throw new Error("Expected the field `kontaktImage` to be a primitive type in the JSON string but got " + data['kontaktImage']);
      }
      // ensure the json data is a string
      if (data['lieferadresseKz'] && !(typeof data['lieferadresseKz'] === 'string' || data['lieferadresseKz'] instanceof String)) {
        throw new Error("Expected the field `lieferadresseKz` to be a primitive type in the JSON string but got " + data['lieferadresseKz']);
      }
      // ensure the json data is a string
      if (data['yesVerifiedAdresseKz'] && !(typeof data['yesVerifiedAdresseKz'] === 'string' || data['yesVerifiedAdresseKz'] instanceof String)) {
        throw new Error("Expected the field `yesVerifiedAdresseKz` to be a primitive type in the JSON string but got " + data['yesVerifiedAdresseKz']);
      }
      if (data['fileList']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['fileList'])) {
          throw new Error("Expected the field `fileList` to be an array in the JSON data but got " + data['fileList']);
        }
        // validate the optional field `fileList` (array)
        var _iterator2 = _createForOfIteratorHelper(data['fileList']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _MandantFile.default.validateJSON(item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      // ensure the json data is a string
      if (data['agb'] && !(typeof data['agb'] === 'string' || data['agb'] instanceof String)) {
        throw new Error("Expected the field `agb` to be a primitive type in the JSON string but got " + data['agb']);
      }
      // ensure the json data is a string
      if (data['sammelPostkorb'] && !(typeof data['sammelPostkorb'] === 'string' || data['sammelPostkorb'] instanceof String)) {
        throw new Error("Expected the field `sammelPostkorb` to be a primitive type in the JSON string but got " + data['sammelPostkorb']);
      }
      // ensure the json data is a string
      if (data['vviLink'] && !(typeof data['vviLink'] === 'string' || data['vviLink'] instanceof String)) {
        throw new Error("Expected the field `vviLink` to be a primitive type in the JSON string but got " + data['vviLink']);
      }
      if (data['mandantFooterList']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['mandantFooterList'])) {
          throw new Error("Expected the field `mandantFooterList` to be an array in the JSON data but got " + data['mandantFooterList']);
        }
        // validate the optional field `mandantFooterList` (array)
        var _iterator3 = _createForOfIteratorHelper(data['mandantFooterList']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item = _step3.value;
            _MandantenFooter.default.validateJSON(_item);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      // ensure the json data is a string
      if (data['gpNummer'] && !(typeof data['gpNummer'] === 'string' || data['gpNummer'] instanceof String)) {
        throw new Error("Expected the field `gpNummer` to be a primitive type in the JSON string but got " + data['gpNummer']);
      }
      // ensure the json data is a string
      if (data['issuerUrl'] && !(typeof data['issuerUrl'] === 'string' || data['issuerUrl'] instanceof String)) {
        throw new Error("Expected the field `issuerUrl` to be a primitive type in the JSON string but got " + data['issuerUrl']);
      }

      // ensure the json data is a string
      if (data['searchLieferadresseAktiv'] && !(typeof data['searchLieferadresseAktiv'] === 'string' || data['searchLieferadresseAktiv'] instanceof String)) {
        throw new Error("Expected the field `searchLieferadresseAktiv` to be a primitive type in the JSON string but got " + data['searchLieferadresseAktiv']);
      }

      // ensure the json data is a string
      if (data['abwAdresseBsErlaubt'] && !(typeof data['abwAdresseBsErlaubt'] === 'string' || data['abwAdresseBsErlaubt'] instanceof String)) {
        throw new Error("Expected the field `abwAdresseBsErlaubt` to be a primitive type in the JSON string but got " + data['abwAdresseBsErlaubt']);
      }
      return true;
    }
  }]);
}();
Mandanteninfos.RequiredProperties = ["theme", "headertitle", "headerLink", "headerlogo1", "headeralt1", "telefon", "mail", "rueckruf", "terminLink", "chat", "bildschirmteilen", "kontaktdaten", "mailTitle", "rueckrufTitle", "terminLinkTitle", "chatTitle", "bildschirmteilenTitle", "kontaktdatenTitle", "kontaktImage", "lieferadresseKz", "yesVerifiedAdresseKz", "agb", "sammelPostkorb", "vviLink", "mandantFooterList", "id", "gpNummer", "searchLieferadresseAktiv", "abwAdresseBsErlaubt"];

/**
 * Bankentyp
 * @member {String} theme
 */
Mandanteninfos.prototype['theme'] = undefined;

/**
 * Sorten Konditionen Kürzel
 * @member {String} soKonditionenKz
 */
Mandanteninfos.prototype['soKonditionenKz'] = undefined;

/**
 * Edelmetall Konditionen Kennzeichen
 * @member {String} emKonditionenKz
 */
Mandanteninfos.prototype['emKonditionenKz'] = undefined;

/**
 * Titel des Headers
 * @member {String} headertitle
 */
Mandanteninfos.prototype['headertitle'] = undefined;

/**
 * Link zu Header
 * @member {String} headerLink
 */
Mandanteninfos.prototype['headerLink'] = undefined;

/**
 * Pfad zu Logo 1
 * @member {String} headerlogo1
 */
Mandanteninfos.prototype['headerlogo1'] = undefined;

/**
 * Pfad zu Logo 2
 * @member {String} headerlogo2
 */
Mandanteninfos.prototype['headerlogo2'] = undefined;

/**
 * Pfad zu Logo 3
 * @member {String} headerlogo3
 */
Mandanteninfos.prototype['headerlogo3'] = undefined;

/**
 * alte Headerdaten
 * @member {String} headeralt1
 */
Mandanteninfos.prototype['headeralt1'] = undefined;

/**
 * alte Headerdaten
 * @member {String} headeralt2
 */
Mandanteninfos.prototype['headeralt2'] = undefined;

/**
 * alte Headerdaten
 * @member {String} headeralt3
 */
Mandanteninfos.prototype['headeralt3'] = undefined;

/**
 * Header Bankname Teil 1
 * @member {String} headerbankname1
 */
Mandanteninfos.prototype['headerbankname1'] = undefined;

/**
 * Header Bankname Teil 2
 * @member {String} headerbankname2
 */
Mandanteninfos.prototype['headerbankname2'] = undefined;

/**
 * Telefonnummer
 * @member {String} telefon
 */
Mandanteninfos.prototype['telefon'] = undefined;

/**
 * Mail-Adresse
 * @member {String} mail
 */
Mandanteninfos.prototype['mail'] = undefined;

/**
 * Telefonnummer
 * @member {String} rueckruf
 */
Mandanteninfos.prototype['rueckruf'] = undefined;

/**
 * Link zum Termin vereinbaren
 * @member {String} terminLink
 */
Mandanteninfos.prototype['terminLink'] = undefined;

/**
 * Chat Kanal
 * @member {String} chat
 */
Mandanteninfos.prototype['chat'] = undefined;

/**
 * Url zum Bildschirm teilen
 * @member {String} bildschirmteilen
 */
Mandanteninfos.prototype['bildschirmteilen'] = undefined;

/**
 * Url zu Kontaktdaten
 * @member {String} kontaktdaten
 */
Mandanteninfos.prototype['kontaktdaten'] = undefined;

/**
 * Titel zur Mail
 * @member {String} mailTitle
 */
Mandanteninfos.prototype['mailTitle'] = undefined;

/**
 * Titel zur Telefonnummer
 * @member {String} rueckrufTitle
 */
Mandanteninfos.prototype['rueckrufTitle'] = undefined;

/**
 * Titel zur Link für Terminvereinbarung
 * @member {String} terminLinkTitle
 */
Mandanteninfos.prototype['terminLinkTitle'] = undefined;

/**
 * Konstante für Titel zum Chat
 * @member {String} chatTitle
 */
Mandanteninfos.prototype['chatTitle'] = undefined;

/**
 * Konstante für Titel zum Bildschirmteilen
 * @member {String} bildschirmteilenTitle
 */
Mandanteninfos.prototype['bildschirmteilenTitle'] = undefined;

/**
 * Konstante für Titel zu Kontaktdaten
 * @member {String} kontaktdatenTitle
 */
Mandanteninfos.prototype['kontaktdatenTitle'] = undefined;

/**
 * Url zu Kontaktdaten Bild
 * @member {String} kontaktImage
 */
Mandanteninfos.prototype['kontaktImage'] = undefined;

/**
 * Lieferadresse kürzel
 * @member {String} lieferadresseKz
 */
Mandanteninfos.prototype['lieferadresseKz'] = undefined;

/**
 * Kürzel für YES-Adresse
 * @member {String} yesVerifiedAdresseKz
 */
Mandanteninfos.prototype['yesVerifiedAdresseKz'] = undefined;

/**
 * Liste an zugeordneten Dateien
 * @member {Array.<module:model/MandantFile>} fileList
 */
Mandanteninfos.prototype['fileList'] = undefined;

/**
 * Link zur AGB
 * @member {String} agb
 */
Mandanteninfos.prototype['agb'] = undefined;

/**
 * Mail-Adresse des Sammelpostkorbs für den Mandanten
 * @member {String} sammelPostkorb
 */
Mandanteninfos.prototype['sammelPostkorb'] = undefined;

/**
 * Link
 * @member {String} vviLink
 */
Mandanteninfos.prototype['vviLink'] = undefined;

/**
 * Liste von Mandanten Footern
 * @member {Array.<module:model/MandantenFooter>} mandantFooterList
 */
Mandanteninfos.prototype['mandantFooterList'] = undefined;

/**
 *
 * @member {Number} id
 */
Mandanteninfos.prototype['id'] = undefined;

/**
 *
 * @member {String} gpNummer
 */
Mandanteninfos.prototype['gpNummer'] = undefined;

/**
 *
 * @member {String} issuerUrl
 */
Mandanteninfos.prototype['issuerUrl'] = undefined;

/**
 *
 * @member {Number} schwellenwert
 */
Mandanteninfos.prototype['schwellenwert'] = undefined;

/**
 *
 * @member {String} searchLieferadresseAktiv
 */
Mandanteninfos.prototype['searchLieferadresseAktiv'] = undefined;

/**
 *
 * @member {String} abwAdresseBsErlaubt
 */
Mandanteninfos.prototype['abwAdresseBsErlaubt'] = undefined;
var _default = exports.default = Mandanteninfos;